import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faInstagram, faTiktok, faFacebook, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { InputComponent } from '../input/input.component';
import { InputPhoneComponent } from '../input-phone/input-phone.component';
import { ButtonComponent } from '../button/button.component';
import { CommonService } from '../../services/common.service';
import { CompaniesService } from '../../services/companies.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-companies',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, InputComponent, InputPhoneComponent, ButtonComponent, FormsModule, ReactiveFormsModule, TranslateModule],
  templateUrl: './companies.component.html',
  styleUrl: './companies.component.scss'
})
export class CompaniesComponent {
  faInstagram = faInstagram
  faTiktok = faTiktok
  faFacebook = faFacebook
  faMail = faEnvelope
  faWhatsapp = faWhatsapp

  isLoading = false;
  errorMessage = '';

  registered: null | true | false = null;

    phoneForm = new FormGroup({
      phone: new FormControl(null,[Validators.required]),
    })
  
  
    companyForm = new FormGroup({
      name: new FormControl('',[Validators.required]),
      email: new FormControl('',[Validators.required, Validators.email]),
      address: new FormControl('',[Validators.required]),
      web: new FormControl('',[Validators.required]),
      phone: new FormControl('',[Validators.required]),
      companyName: new FormControl('',[Validators.required]),
      companyType: new FormControl('',[Validators.required]),
      instagram: new FormControl('',[Validators.required]),
    })


    constructor(private commonService: CommonService, private companiesService: CompaniesService){}


    onSubmit() {
      if(this.phoneForm.valid){
        const phoneObject = this.phoneForm.get('phone')?.value
        if(phoneObject){
          this.companyForm.get('phone')?.patchValue(phoneObject['e164Number']);
        }else{
          this.companyForm.get('phone')?.patchValue(null);
        }
      }else{
        this.companyForm.get('phone')?.patchValue(null);
      }      
  
      
      this.companyForm.markAllAsTouched();
      this.commonService.markFormGroupDirty(this.companyForm)

      this.phoneForm.markAllAsTouched();
      this.commonService.markFormGroupDirty(this.phoneForm)
  
      if (this.companyForm.valid) {
        this.isLoading = true;
        this.errorMessage = '';
        const { name, email, web, address, phone, companyName, companyType, instagram } = this.companyForm.value;
  
        if(!name || !email || !web || !address || !phone || !companyName || !companyType || !instagram) return 
  
        this.companiesService.register(name, email, web, address, phone, companyName, companyType, instagram).subscribe(
          (response) => {
            this.isLoading = false;
            this.registered = true

            this.phoneForm.reset()
            this.companyForm.reset()
          },
          (error) => {
            this.registered = false
            console.error('Error durante el registro:', error);
            this.isLoading = false;
            this.errorMessage = error.error.message ?? 'Error al registrar. Por favor, inténtalo de nuevo.';
          }
        );
      }
    }
}
